import { MaterialUICore, TextArea, tokens } from '@iclinic/design-system';

import Modal from 'ui/new/modal';

const { styled } = MaterialUICore;

const flexRowJustified = {
  display: 'flex',
  justifyContent: 'space-between',
};

export const PaymentInfoContainer = styled('section')(() => ({
  width: '100%',
  padding: '0 23px',
  display: 'flex',
  flexDirection: 'column',
  fontFamily: tokens.font.family.base,
  color: tokens.color.neutral[900],
  fontSize: tokens.font.size.xs,
  marginTop: tokens.spacing.lg,
  '& > .payment_info_header': {
    ...flexRowJustified,
  },
  '& > .payment_info_header > .payment_info_title': {
    fontSize: tokens.font.size.sm,
    fontWeight: tokens.font.weight.bold,
    marginBottom: tokens.spacing.lg,
  },
  '& > .payment_method_title': {
    fontWeight: tokens.font.weight.bold,
    marginBottom: tokens.spacing.base,
  },
  '& > .payment_method_info': {
    marginBottom: tokens.spacing.md,
    color: tokens.color.neutral[700],
  },
}));

export const PaymentInfoObservationsArea = styled(TextArea)({
  '& textarea::placeholder': {
    color: tokens.color.neutral[300],
  },
  '& > textarea': {
    height: '150px',
  },
});

export const AddPaymentMethodContainer = styled(Modal)(({ theme }) => ({
  fontFamily: tokens.font.family.base,
  backgroundColor: tokens.color.primary.light,
  display: 'flex',
  flexDirection: 'column',

  gap: tokens.spacing.xs,
  [theme.breakpoints.down('md')]: {
    width: '90%',
  },
}));

export const ModalContent = styled('div')({
  '& > .payment_method_modal_title': {
    ...flexRowJustified,
    fontFamily: tokens.font.family.base,
    height: '56px',
    fontSize: tokens.font.size.sm,
    fontWeight: tokens.font.weight.bold,
    '& > div:last-child': {
      cursor: 'pointer',
    },
  },
  '& > .payment_method_form': {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacing.xs,
    '& > .total_value': {
      fontSize: tokens.font.size.md,
      fontWeight: tokens.font.weight.bold,
      margin: `${tokens.spacing.sm} 0 ${tokens.spacing.xs}`,
    },
    '& > .total_value, .amount_info, .amount_info_alert': {
      ...flexRowJustified,
    },
    '& > .amount_info_alert': {
      color: tokens.color.feedback.error.main,
    },
  },
});

export const PaymentList = styled('ul')({});

export const PaymentItem = styled('li')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  padding: '13px 14px',
  width: '100%',
  gap: 10,
  fontFamily: tokens.font.family.base,
  fontWeight: tokens.font.weight.regular,
  fontSize: tokens.font.size.sm,
  '& > div:last-child': {
    fontSize: tokens.font.size.xs,
  },
});

export const PaymentItemInfo = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  '& > span.payment-item-description': {
    width: 623,
    marginLeft: tokens.spacing.sm,
  },
  '& > span.payment-item-value': {
    marginRight: 22,
    textAlign: 'right',
    minWidth: 129,
  },
});

export const ImgIcon = styled('img')({
  width: tokens.font.size.md,
  height: tokens.font.size.md,
});
